/* eslint-disable prettier/prettier */
import $ from 'jquery';
import axios from 'axios';
import _ from 'lodash';
import M from 'materialize-css';

window.initializeUserConversationsBroadcast = (userId) => {
  window.Echo.private(`user.conversations.${userId}`).listen('ConversationUsersListener', ({ message }) => newMessage(message));
};

// Override the normal submit and take it over with Axios
$('.send-message').on('submit', function(event) {
  event.preventDefault();

  const conversationId = $(event.target).data('conversation_id');
  const button = $(`#msg-btn-${conversationId}`);
  const _chatBox = $(`#conversation-${conversationId}`);

  button.attr('disabled', true);


  axios({
    url: `/conversations/${conversationId}/messages`, // route:frontend.conversations.messages.store
    method: 'POST',
    data: {
      content: _chatBox.val(),
    }
  }).then(function({ data: { message } }) {
    _chatBox.val('');
    M.textareaAutoResize(_chatBox);
    _chatBox.trigger('focus');
    
    $('#status-id').val('');
    button.attr('disabled', false);

    // eslint-disable-next-line no-param-reassign
    message.sender = false;
    newMessage(message);
  });
});

// eslint-disable-next-line consistent-return
function newMessage(message) {
  const messageBox = $(`#messages-list-${message.conversationId}`);

  if (!messageBox.length) {
    return newNotification(message);
  }

  messageBox.append(getMessageTemplateHtml(message));

  messageBox.prop('scrollTop', messageBox.prop('scrollHeight'));

  messageBox.children('#no-messages').remove();

  if (messageBox.is(':visible')) {
    updateLastViewed(message);
  } else {
    newNotification(message);
  }
}

function getMessageTemplateHtml(message) {
  const messageType = getMessageType(message);

  let messageHtml = $(`#messages-list-${message.conversationId} .message-templates .message-card.${messageType}`)
    .parents('.message-row')
    .wrap('<p/>')
    .parent()
    .html();

  if (message.sender) {
    messageHtml = messageHtml.replace('-=sender=-', message.sender);
  }

  messageHtml = messageHtml.replace('-=content=-', message.content.replace(/\n/g, '<br>'));
  messageHtml = messageHtml.replace('-=time=-', message.time);

  return messageHtml;
}

function getMessageType(message) {
  if (message.isSystemMessage) {
    return 'system';
  }

  if (message.sender) {
    return 'received';
  }

  return 'send';
}

function updateLastViewed(message) {
  axios({
    url: `/conversations/${message.conversationId}/messages-synced`, // route:frontend.conversations.messages-synced
    method: 'POST',
    data: {
      _method: 'patch',
    },
  });
}

window.markAsRead = (message) => {
  updateLastViewed(message);
  newNotification(message, true);
};

function newNotification(message, markAsRead = false) {
  const { conversationId, applicationId, vacancyId, organizationId, isInvitation } = message;
  const notificationTypes = [];

  if (!markAsRead) {
    notificationTypes.push({ display: 'all' });
  }

  if (!window.organizationId()) {
    if (!organizationId) {
      notificationTypes.push({ display: 'conversations', value: conversationId }, { display: `conversation-${conversationId}` });

      if (isInvitation) {
        notificationTypes.push({ display: 'invitations', value: conversationId });
      }
    }

    if (applicationId) {
      notificationTypes.push({ display: 'applications', value: applicationId }, { display: `application-${applicationId}` });
    }
  } else if (organizationId) {
    if (vacancyId) {
      notificationTypes.push(
        { display: `organization-${organizationId}-vacancies`, value: vacancyId },
        { display: `organization-${organizationId}-vacancy-${vacancyId}` }
      );
    }

    if (applicationId) {
      notificationTypes.push(
        { display: `organization-${organizationId}-applications`, value: applicationId },
        { display: `organization-${organizationId}-application-${applicationId}` }
      );
    }
  }

  _.forEach(notificationTypes, ({ display, value = false }) => {
    const $badges = $(`.notification-badge[data-display="${display}"]`);
    const defaultValue = value ? [] : 0;
    const unread = $badges.data('unread') || defaultValue;

    if (value) {
      if (!_.includes(unread, value)) {
        if (!markAsRead) {
          unread.push(value);

          $badges.data('unread', unread);
        }
      } else if (markAsRead) {
        _.pull(unread, value);

        $badges.data('unread', unread);
      }
    } else if (markAsRead) {
      $badges.data('unread', 0);
    } else {
      $badges.data('unread', unread + 1);
    }

    showUnread($badges);
  });
}

function showUnread($badge) {
  if ($badge.length > 1) {
    _.forEach($badge, (badge) => {
      showUnread($(badge));
    });

    return;
  }

  const unread = $badge.data('unread');

  let count = unread;

  if (Array.isArray(unread)) {
    count = unread.length;
  }

  if (count) {
    $badge.text(count);
    $badge.addClass('notification-visible');
  } else {
    $badge.html('&nbsp');
    $badge.removeClass('notification-visible');
  }
}

window.showNotifications = () => {
  _.forEach($('.notification-badge'), (badge) => {
    showUnread($(badge));
  });
};

$(document).ajaxComplete(() => {
  window.showNotifications();
});
